import Vue from 'vue';
import Vuex from 'vuex';

import ssv2300ConfiOpedaWs from '@/store/ssv2300-confi-opeda-ws.module';

import ssv2307UsuroCadtrCrtor from '@/store/ssv2307-usuro-cadtr-crtor.module';

import ssv2308ExcecRadarCotac from '@/store/ssv2308-excec-radar-cotac.module';

import ssv2314CadtrFlagWs from '@/store/ssv2314-cadtr-flag-ws.module';

import ssv2340ConfiCrtorWs from '@/store/ssv2340-confi-crtor-ws.module';

import ssv2341ConfiCrtorFlagWs from '@/store/ssv2341-confi-crtor-flag-ws.module';

import ssv2303ConfiAutoFncra from '@/store/ssv2303-confi-auto-fncra.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {

    ssv2300ConfiOpedaWs,

    ssv2307UsuroCadtrCrtor,

    ssv2308ExcecRadarCotac,

    ssv2314CadtrFlagWs,

    ssv2340ConfiCrtorWs,

    ssv2341ConfiCrtorFlagWs,

    ssv2303ConfiAutoFncra

  }
});